/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import App from "./App.vue";
import constants from "./constants";
// import '@/views/components/animate-background.js';

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// axios
import axios from "./axios.js";
Vue.prototype.$http = axios;

// Theme Configurations
import "../themeConfig.js";

// ACL
// import acl from './acl/acl'

import VueFullscreen from "vue-fullscreen";
Vue.use(VueFullscreen);

// VeeValidate
import VeeValidate from "vee-validate";
Vue.use(VeeValidate);

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// i18n
import i18n from "./i18n/i18n";

// Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    // key: 'AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y',
    key: "AIzaSyAjhJvqS_DiX9MRAwE7gBsO4dJndNjDGk8",
    libraries: "places", // This is required if you use the Auto complete plug-in
  },
});

// Azure Active Directory
import Emitter from "tiny-emitter";
Vue.prototype.$msalInstance = {};
Vue.prototype.$emitter = new Emitter();

// Vue Tour
import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

// Vue OTP Input
import VueOtp2 from "vue-otp-2";
Vue.use(VueOtp2);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// Vue js parallex effect plugin
// import VueRellax from 'vue-rellax'
// Vue.use(VueRellax)

// Vue clipper (In case you uninstall this, uninstall vue-rx also) - Image cropping
import VueRx from "vue-rx";
// Use build files
import VuejsClipper from "vuejs-clipper/dist/vuejs-clipper.umd";
import "vuejs-clipper/dist/vuejs-clipper.css";
Vue.use(VueRx);
Vue.use(VuejsClipper);

// Google Tag Manager
import VueGtm from "@gtm-support/vue2-gtm";
Vue.use(VueGtm, {
  id: "GTM-N7P5NJJ", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  /*queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview: 'env-4',
    gtm_cookies_win: 'x'
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick*/
});

// ToDo
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from 'socket.io-client'
// const options = {
//   extraHeaders: {
//     'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
//   },
//   transports: ['websocket'],
//   autoConnect: false
// }; //Options object to pass into SocketIO
// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: SocketIO(constants.apiHost, options), //options object is Optional
//   vuex: {
//     store,
//     actionPrefix: "SOCKET_",
//     mutationPrefix: "SOCKET_"
//   }
// })
// );

// Vuexy Admin Filters
import "./filters/filters";

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

// Feather font icon
require("./assets/css/iconfont.css");

// Global Styles
require("./assets/css/globalStyle.css");

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  // acl,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
